import React from 'react';

import { SvgProps } from '..';

const Anonymous = ({ scale = 1, color = '#FFFFFF', viewBox = '0 0 16 16' }: SvgProps) => {
  const width = `${scale * 16}`;
  const height = `${scale * 16}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path d="M3.5 5.50098H12.5" stroke={color} strokeLinecap="round" />
      <path
        d="M7 11.501C7 11.501 7.56338 11.001 8 11.001C8.43662 11.001 9 11.501 9 11.501"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M3 7.00075C3 7.00075 3.14176 2.07352 5.5 2.00075C6.55102 1.96832 6.94848 3.00075 8 3.00075C9.05152 3.00075 9.44898 1.96832 10.5 2.00075C12.8582 2.07352 13 7.00075 13 7.00075"
        stroke={color}
        strokeLinecap="round"
      />
      <rect x="1" y="7" width="14" height="2" rx="1" stroke={color} />
      <rect x="4" y="11.001" width="3" height="3" rx="1.5" stroke={color} />
      <rect x="9" y="11.001" width="3" height="3" rx="1.5" stroke={color} />
    </svg>
  );
};

export default Anonymous;
